import { render, staticRenderFns } from "./MobileBottomBar.vue?vue&type=template&id=a751de5e&"
import script from "./MobileBottomBar.vue?vue&type=script&lang=js&"
export * from "./MobileBottomBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports